/**
 * Type of ingredients.
 */
export type CiderIngredientType = 'APPLE' | 'PEAR' | 'OTHER';

export const CiderIngredientType = {
  Apple: 'APPLE' as CiderIngredientType,
  Pear: 'PEAR' as CiderIngredientType,
  Other: 'OTHER' as CiderIngredientType,
};
